import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
  icons: {
    iconfont: 'mdiSvg',
    //iconfont: 'fa',
   }
}

export default new Vuetify(opts)



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js